module.exports = __webpack_public_path__ + "static/images/icon-geocode-parked-equipment-suggestion.svg";